import ReactPatternLock from "./components/PatternLock";
export default ReactPatternLock;
//# sourceMappingURL=index.js.map